<template>
    <div class="relative flex flex-col w-full" >
        <div class="grid grid-cols-7 w-full border border-theme-green rounded">
            <div class="cursor-pointer" v-for="option in options" :key="'brd-'+option">
                <div :class="isAdded(option)?'bg-theme-green bg-opacity-[32%]':'bg-none'" class="border-r border-theme-green py-[8px] text-center" @click="select(option)">{{ option }}</div>
            </div>
        </div>
    </div>
    </template>
    <script>
    import {defineComponent} from 'vue'
    export default defineComponent({
        props: {
            modelValue: String,
            options: Array
        },
        data(){
            return {
                selected: []
            }
        },
        mounted(){
            if(this.modelValue && this.modelValue.length>0){
                this.selected = this.modelValue
            }else{
                this.selected = []
            }
        },
        watch: {
            modelValue(){
                if(this.modelValue && this.modelValue.length>0){
                    this.selected = this.modelValue
                }else{
                    this.selected = []
                }
            }
        },
        methods: {

            isAdded(day){
                if(this.selected){
                    return this.selected.includes(day)
                }
            },

            select(day){
                if(this.selected && this.selected.length>0){
                    const ind = this.selected.indexOf(day)
                    if(ind>-1){
                        this.$emit('changed', 'removed', day)
                        this.selected.splice(ind, 1)
                    }else{
                        this.$emit('changed', 'added', day)
                        this.selected.push(day)
                    }
                }else{
                    this.$emit('changed', 'added', day)
                    this.selected.push(day)
                }
                this.$emit('update:modelValue', this.selected)
                this.$emit('change', this.selected)
            }
        }
    })
    </script>